import React from 'react'
import News from '../ui/news'
import Formulas from '../ui/formulas'
import UserEmailRequest from '../ui/userEmailRequest'
import Footer from '../ui/footer'

export default class App extends React.Component {

    render() {
        return (
            <div>
                <UserEmailRequest />
                <div className=" wrapper">
                    <div className="container-fluid">
                        <News />
                    </div>
                    <div className="container-fluid">
                        <Formulas />
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}